export default {
    name: "ParticipantLogic",
    props: {
        data: { type: Object }
    },

    computed: {
        isRemote() {
            return this.data.type === "remote";
        },

        peerId() {
            return this.data.peer_id;
        },

        isMuted() {
            return this.data.playerMuted;
        },

        mediaSource() {
            return this.data.mediaSource;
        },

        displayName() {
            return this.data.userData.displayName;
        },

        peerError() {
            return this.data.userData.peerState && this.data.userData.peerState.error;
        },

        isMicCut() {
            return (
                this.data.userData.peerState &&
                this.data.userData.peerState.isMicCut
            );
        },

        isRecording() {
            return (
                this.data.userData.peerState &&
                this.data.userData.peerState.isRecording
            );
        },

        audioDeviceLabel() {
            return (
                this.data.userData.peerState &&
                this.data.userData.peerState.audioDevice
            );
        },

        videoDeviceLabel() {
            return (
                this.data.userData.peerState &&
                this.data.userData.peerState.videoDevice
            );
        },
        
        hasVideo() {
            return this.data.mediaSource && this.data.mediaSource.getVideoTracks().length > 0;
        },

        audioContext() {
            return this.$store.getters["audioContext"];
        },

        audioElement() {
            return this.$refs.audioElement;
        },

        browserType() {
            let { userData } = this.data;
            let { peerState} = userData;
            let { browser } = peerState;
            return browser && browser.name;
        }
    },

    methods: {
        toggleMute: function() {
            this.data.playerMuted = !this.data.playerMuted;
        },
    },

    mounted() {
        // // This abomination is a fix for iOS safari - based on https://github.com/twilio/twilio-video.js/issues/922
        // let el = this.$refs.audioElement;

        // el.addEventListener("play", function onPlay() {
        //     el.removeEventListener("play", onPlay);
        //     el.addEventListener("pause", function onPause() {
        //         el.removeEventListener("pause", onPause);
        //         setTimeout(() => {
        //             el.play();
        //         }, 500);
        //     });
        //     el.pause();
        // });
    },
};